module.exports = __webpack_public_path__ + "../resources/images/illustration_flagged-00ad7817c743532a04a1b69c7bdd072d.svg";